<template>
  <div class="warn-types none-height d-flex flex-column flex-grow-1">
    <div
      class="selector-container d-flex section-container"
      :class="{ dark: skinType }"
    >
      <SectionTitle title="数据备份"></SectionTitle>
      <el-form :inline="true" style="text-align: left" size="small">
        <el-form-item label="关键字" :class="{ 'light-label': skinType }">
          <el-input v-model="keywords" placeholder="关键字"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
          <el-button @click="exportTable">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      size="small"
      :data="tableData"
      class="none-height flex-grow-1"
      style="width: 100%"
      height="0"
      ref="table"
      row-key="TabID"
      stripe
            default-expand-all
      :tree-props="{ children: 'children' }"
      :class="{ dark: skinType }"
      :row-class-name="
        (...nu) => {
          return skinType ? 'dark text-white' : '';
        }
      "
    >
          <el-table-column fixed type="index" width="60" label="#">
          </el-table-column>
          <el-table-column
            prop="F_DbName"
            label="数据库名"
            width="150"
          ></el-table-column>
          <el-table-column prop="F_FileName" label="备份名称" min-width="160">
          </el-table-column>
          <el-table-column prop="F_FileSize" label="大小" width="110">
          </el-table-column>
          <el-table-column prop="F_BackupType" label="备份模式" width="160">
          </el-table-column>
          <el-table-column prop="F_CreatorTime" label="备份时间" width="140">
          </el-table-column>
          <el-table-column prop="F_CreatorUserId" label="备份人员" width="120">
          </el-table-column>
          <el-table-column
            prop="F_Description"
            label="备份说明"
            width="120"
          >
          </el-table-column>
          <el-table-column fixed="right" label="功能" width="160">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.row)"
               :plain="!skinType">删除</el-button>
              <el-button
                size="mini"
                @click="handleDownload(scope.row)"
              >下载</el-button>
            </template>
          </el-table-column>
    </el-table>
    <div
      class="d-flex section-container"
      style="padding: 1rem"
      :class="{ dark: skinType }"
    >
      <el-pagination
        v-if="pageInfo.total"
        style="margin-left: auto"
        background
        :class="{ 'text-white': skinType }"
        layout="total, prev, pager, next"
        :total="pageInfo.total"
        :current-page.sync="pageIndex"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import SectionTitle from '@/components/utils/section-title.vue';
import { getBackupList, delBackup, downloadBackup } from '@/api/system-safety/index';
import { exportExcel } from '@/utils/utils';
import { showConfirm } from '@/utils/dialog';

export default {
  name: 'warn-types',
  components: {
    SectionTitle,
  },
  data() {
    return {
      pageIndex: 1,
      pageInfo: {
        index: 1,
        size: 10,
        total: 1,
      },
      tableData: [],
      keywords: null,
      diaTitle: '',
      dialogVisible: false,
      selectWarnType: {},
    };
  },
  created() {
    this.requestBackupList();
  },
  watch: {
    pageIndex() {
      this.requestBackupList();
    },
    // 申请时间
    keywords() {
      if (this.pageIndex !== 1) {
        this.pageIndex = 1;
        return;
      }
      this.requestBackupList();
    },
    // 申请类型
    applyClass() {
      if (this.pageIndex !== 1) {
        this.pageIndex = 1;
        return;
      }
      this.requestBackupList();
    },
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    onSubmit() {
      this.requestBackupList();
    },
    exportTable() {
      exportExcel(this.$refs.table.$el);
    },
    pageChangeListener(no) {
      this.pageIndex = no;
    },
    requestBackupList() {
      getBackupList({
        page: this.pageIndex,
        rows: this.pageInfo.size,
        keyword: this.keywords,
      }).then((res) => {
        this.tableData = res.rows || res;
        this.pageInfo.total = res.total || 0;
      });
    },
    // 删除
    handleDelete(type) {
      const formData = new FormData();
      formData.append('keyValue', type.F_Id);
      showConfirm('数据备份', () => delBackup(formData), this).then(this.requestBackupList);
    },
    handleDownload(type) {
      const formData = new FormData();
      formData.append('keyValue', type.F_Id);
      downloadBackup(formData);
    },
  },
};
</script>

<style scoped>

</style>
